import React, { useEffect, useState } from 'react';

const FlowerDivider: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    
    const element = document.getElementById('flower-divider');
    if (element) observer.observe(element);
    
    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  return (
    <div 
      id="flower-divider"
      className="relative py-16 overflow-hidden z-10"
    >
      {/* Fondo con degradado sutil que se integra con el fondo general */}
      <div className="absolute inset-0 bg-gradient-radial from-cream/10 via-transparent to-transparent"></div>
      
      {/* Capa semi-transparente para suavizar la transición */}
      <div className="absolute inset-0 backdrop-blur-[0.5px]"></div>
      
      <div className="max-w-6xl mx-auto px-4 relative z-10">
        <div 
          className={`flex flex-col items-center transition-all duration-1000 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Líneas decorativas con nueva opacidad para mejor integración */}
          <div className="w-full flex items-center justify-center gap-4 mb-8">
            <div className="flex-1 h-px bg-sage/25"></div>
            <div className="w-2 h-2 rounded-full bg-sage/35"></div>
            <div className="flex-1 h-px bg-sage/25"></div>
          </div>
          
          {/* Imagen de la flor con efecto de resplandor sutil */}
          <div className="relative w-32 h-32 mb-8">
            <div className="absolute inset-0 rounded-full bg-cream/10 filter blur-xl transform scale-75"></div>
            <img 
              src="/lovable-uploads/423f3590-dcc9-41b0-8eb2-98ad70f161ef.png" 
              alt="Flor decorativa" 
              className="w-full h-full object-contain relative z-10"
            />
          </div>
          
          {/* Líneas decorativas */}
          <div className="w-full flex items-center justify-center gap-4">
            <div className="flex-1 h-px bg-sage/25"></div>
            <div className="w-2 h-2 rounded-full bg-sage/35"></div>
            <div className="flex-1 h-px bg-sage/25"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlowerDivider; 